// スマホ表示のとき、SNSアイコンを下に貼り付ける。
//
//  以下は不採用となった。
//
// document.addEventListener("DOMContentLoaded", () => {
//     var elem = document.getElementById('fixed-position');

//     if (elem != undefined) {
//         var rect = elem.getBoundingClientRect();
//         var elembotom = rect.bottom + window.scrollY;;
//         // console.log(`btm:${elembotom}`)

//         if (window.innerWidth < 768) {
//             // 横幅 md:768 以上の場合
//             var flg = true;
//             window.addEventListener("scroll", function() {
//                 scroll_position = window.scrollY + window.innerHeight;
//                 // console.log(scroll_position);

//                 if (scroll_position <= elembotom) {
//                     //下に固定
//                     if (flg == false) {
//                         elem.style.position = "fixed";
//                         flg = true;
//                     }
//                 } else {
//                     // デフォルト表示位置のまま
//                     if (flg == true) {
//                         elem.style.position = "static";
//                         flg = false;
//                     }
//                 }
//             })
//         }
//     }
// })



